/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { StyledModal } from 'sarsaparilla';

import DivisionDetail from './DivisionDetail';

function DivisionDetailsModal({
    permit,
    divisionId,
    isOpen,
    onRequestClose,
    hasMap,
    permitMapping,
}) {
    return (
        <StyledModal
            shouldShowCloseButton
            shouldActionsStickInMobile
            size={hasMap ? 'xxl' : 'md'}
            isOpen={isOpen}
            heading={permit?.divisions?.[divisionId]?.name}
            onRequestClose={onRequestClose}
        >
            <DivisionDetail
                divisionId={divisionId}
                permit={permit}
                hasMap={hasMap}
                permitMapping={permitMapping}
            />
        </StyledModal>
    );
}

DivisionDetailsModal.propTypes = {
    permit: PropTypes.object,
    divisionId: PropTypes.string,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    hasMap: PropTypes.bool,
    permitMapping: PropTypes.object,
};

export default DivisionDetailsModal;
